import { Flex, IconButton, Spacing } from '@billy/design-system'
import { ReactElement } from 'react'

import * as Styled from './styles'

interface ReviewEntryDetailNavHeaderProps {
  currentIndex?: number
  onClose: () => void
  onNavigateNext?: () => void
  onNavigatePrevious?: () => void
  totalCount?: number
}

export const ReviewEntryDetailNavHeader = ({
  currentIndex,
  onClose,
  onNavigateNext,
  onNavigatePrevious,
  totalCount,
}: ReviewEntryDetailNavHeaderProps): ReactElement => (
  <Styled.ReviewEntryDetailNavHeaderRoot>
    <Flex alignItems="center" gap={Spacing.S8}>
      <IconButton icon="chevronUp" onClick={onNavigatePrevious} variant="outlined" />
      <IconButton icon="chevronDown" onClick={onNavigateNext} variant="outlined" />
      {currentIndex != null && totalCount != null && (
        <Styled.NavCounter>
          {currentIndex}/{totalCount}
        </Styled.NavCounter>
      )}
    </Flex>
    <IconButton icon="x" onClick={onClose} />
  </Styled.ReviewEntryDetailNavHeaderRoot>
)
